
const modules = import.meta.glob('./*.js', { eager: true });
export function mount() {
  for (const [p, mod] of Object.entries(modules)) {
    if (p.endsWith('/index.js')) continue;
    const fn = mod.mount || mod.default;
    if (typeof fn === 'function') { try { fn(); } catch(e){ console.error('[component failed]', p, e); } }
  }
}